<div class="d-flex flex-column align-items-center h-100 justify-content-center">
    <app-image-loader src="assets/{{ facilityName }}/img/empty.svg" width="250px" alt="No credit cards image" />
    <h2 class="mat-headline-5 m-0 text-center">You don’t have any <br />Credit Card(s) saved</h2>
</div>
